export default "__VITE_ASSET__CifsKxlR__"